"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isFetching = exports.getAppconfig = void 0;
const getAppconfig = state => state.appconfig.entity;
exports.getAppconfig = getAppconfig;
const isFetching = state => state.appconfig.fetching;
exports.isFetching = isFetching;